import React from 'react';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import { VISITOR_SUB_VIEW_MODEL } from '../../Invitation/Model/Model';
import SearchSimple from '../../../../../components/SearchSimples/SearchSimple';
import DisplayView from '../../../../../components/DisplayView';
import {VISITOR_VIEWS_FROM} from '../../Guard/Model/Model';
import {permissionObj} from '../../../../../Helpers/permission';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const VisitorMainHeader = (props) => {
    const {
        subView,
        handleSubViewChange,
        setBodyForExport,
        searchElement,
        setSearchElement,
        option,
        rowsPerPage,
        setSimpleSearch,
        search,
        setSearch,
        permission,
        DEV,
        userId,
        view,
        setView,
        setResults,
        viewOrigin,
        getData
    } = props;


    const permissionActiveRequest = DEV || permission?.includes(permissionObj.WEB_REQUEST_ACCESS_READ);
    const permissionVisitors =  DEV || permission?.includes(permissionObj.WEB_VISITOR_READ);
    return (
        <div className='d-flex'>

            { viewOrigin == VISITOR_VIEWS_FROM.VISITOR_MANAGEMENT &&
                <div className='d-flex'>
                    { permissionVisitors &&
                    <ButtonAction
                        id='btn_vmh_visitors'
                        name='visitors'
                        className={VISITOR_SUB_VIEW_MODEL.VISITORS.VISITORS === subView ? 'btn-outlined-secondary-600-100 mr-8px' : 'btn-outlined-secondary-600-00 mr-8px'}
                        disabled={false}
                        splitName={false}
                        onClick={() => {
                            if(handleSubViewChange)
                                handleSubViewChange(VISITOR_SUB_VIEW_MODEL.VISITORS.VISITORS)
                        }}
                    />
                    }

                    { permissionActiveRequest  &&
                    <ButtonAction
                        id='btn_vmh_active_request'
                        name='active_requests'
                        className={VISITOR_SUB_VIEW_MODEL.VISITORS.ACTIVE_REQUESTS === subView ? 'btn-outlined-secondary-600-100 mr-8px' : 'btn-outlined-secondary-600-00 mr-8px'}
                        disabled={false}
                        splitName={false}
                        onClick={() => {
                            if(handleSubViewChange)
                                handleSubViewChange(VISITOR_SUB_VIEW_MODEL.VISITORS.ACTIVE_REQUESTS)
                        }}
                    />
                    }
                </div>
            }

            { ( (subView == VISITOR_SUB_VIEW_MODEL.VISITORS.VISITORS || viewOrigin == VISITOR_VIEWS_FROM.VISITOR_GUARD  ) && permissionVisitors )  &&
                <div className="mr-2">
                    <DisplayView view={view} setView={setView} className={''} />
                </div>
            }
            <div className='w-100'>
                <SearchSimple
                    id={'txt_d_search_simple'}
                    setBodyForExport={setBodyForExport}
                    setSearchResults={setResults}
                    setSearchElement={setSearchElement}
                    optionTable={option}
                    rowsPerPage={rowsPerPage}
                    setSimpleSearch={setSimpleSearch}
                    search={search}
                    setSearch={setSearch}
                    searchElement={searchElement}
                    contractorId={userId}
                    callApi={ getData ? () => getData(0, {searchElement})  : null}
                    resetApi={ getData ? () => getData(0, {searchElement: ''}) : null}
                />
            </div>
        </div>
    )
}

export default VisitorMainHeader;
